import { render } from "./Grafics.vue?vue&type=template&id=d8a395f4&scoped=true"
import script from "./Grafics.vue?vue&type=script&lang=js"
export * from "./Grafics.vue?vue&type=script&lang=js"

import "./Grafics.vue?vue&type=style&index=0&id=d8a395f4&scoped=true&lang=css"

import exportComponent from "C:\\projects\\dcc\\site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a395f4"]])

export default __exports__